<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.questions', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <Tabs class="mt-5">
            <Tab :title="questionType.type" v-for="questionType in questionTypes" :key="questionType.type">
                <div v-for="adaptation in questionType.adaptations" :key="adaptation.degree" class="mt-5">
                    <span>{{ adaptation.degree }}</span>

                    <div class="rounded-lg border-2 border-gray-300 py-2 px-3 shadow-lg col-span-2">
                        <div class="font-semibold text-gray-900">
                            {{ adaptation.question.title }}
                        </div>
                        <div class="mt-3 p-2 bg-gray-100 rounded-lg" v-if="adaptation.question.description">
                            <QuestionDescriptionDisplay :question="adaptation.question" />
                        </div>
                        <div class="mt-3 p-2 bg-gray-100 rounded-lg" v-if="adaptation.question.image_path">
                            <img :src="adaptation.question.image_path" alt="cover" class="h-auto" />
                        </div>
                        <div class="mt-3 p-2 bg-gray-100 rounded-lg" v-if="adaptation.question.shared_image">
                            <img :src="adaptation.question.shared_image" alt="cover" class="h-auto" />
                        </div>

                        <HintAlert v-if="adaptation.question.hint" class="mt-1">
                            <span class="font-semibold">{{ $t('messages.hint') }}:</span>
                            {{ adaptation.question.hint }}
                        </HintAlert>

                        <div>
                            <component
                                :is="adaptation.question.type"
                                :question="adaptation.question"
                                v-model="adaptation.question.answer"
                            />
                        </div>
                    </div>
                </div>
            </Tab>
        </Tabs>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import Tabs from '@/components/Tabs.vue';
import Tab from '@/components/Tab.vue';
import HintAlert from '@/components/Quiz/HintAlert.vue';
import QuestionMultipleChoiceQuiz from '@/components/Quiz/QuestionMultipleChoiceQuiz.vue';
import QuestionShortAnswerQuiz from '@/components/Quiz/QuestionShortAnswerQuiz.vue';
import QuestionOrderPhraseQuiz from '@/components/Quiz/QuestionOrderPhraseQuiz.vue';
import QuestionTrueFalseQuiz from '@/components/Quiz/QuestionTrueFalseQuiz.vue';
import QuestionOrderElementsQuiz from '@/components/Quiz/QuestionOrderElementsQuiz.vue';
import QuestionDescriptionDisplay from '@/components/Quiz/QuestionDescriptionDisplay.vue';

export default {
    components: {
        QuestionDescriptionDisplay,
        PanelPage,
        Tabs,
        Tab,
        HintAlert,
        'multiple-choice': QuestionMultipleChoiceQuiz,
        'short-answer': QuestionShortAnswerQuiz,
        'order-phrase': QuestionOrderPhraseQuiz,
        'true-false': QuestionTrueFalseQuiz,
        'order-elements': QuestionOrderElementsQuiz,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'options', 'questionTypes'],
    data() {
        return {};
    },
    methods: {
        submit() {},
    },
};
</script>
